import BaseAPI from '@/apis/base/baseApi';

export default class TAXApi extends BaseAPI {
  apiName = 'TAX';
}
